// Campus photo for /colleges/boston-college: CC BY-SA 4.0, by Amandajunyue, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGasson_Hall_in_Boston_College.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/boston-college/; credited under the photo.
const photo = {
    "slug": "boston-college",
    "alt": "Gasson Hall and its Gothic tower on the Boston College campus in Chestnut Hill, Massachusetts",
    "src": "/colleges/boston-college/campus-1600.webp",
    "srcSmall": "/colleges/boston-college/campus-800.webp",
    "srcMid": "/colleges/boston-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/boston-college/og.jpg",
    "title": "Gasson Hall in Boston College",
    "author": "Amandajunyue",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGasson_Hall_in_Boston_College.jpg",
    "read": "2026-10-01"
};

export default photo;
